const DatosAcceso = ({
  values,
  errors,
  onChange,
  isEditing,
  editPassword,
  onEnablePasswordEdit
}) => {
  const inputClass = (fieldKey) =>
    `w-full rounded-xl border bg-white px-3 py-2.5 text-sm text-slate-900 transition focus:border-red-400 focus:outline-none focus:ring-2 focus:ring-red-200 ${errors[fieldKey] ? 'border-red-500 ring-2 ring-red-100' : 'border-slate-300'
    }`;

  const handleFieldChange = (e) => {
    onChange(e.target.name, e.target.value);
  };

  return (
    <div className="ui-card p-5 md:p-6">
      <div className="mb-4 flex items-center gap-3 border-b border-slate-200 pb-3">
        <div className="h-8 w-1.5 rounded-full bg-red-600" />
        <h3 className="text-base font-semibold uppercase tracking-[0.08em] text-slate-800">DATOS DE ACCESO</h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label htmlFor="username" className="mb-1 block text-xs font-semibold uppercase tracking-[0.08em] text-slate-600">
            USUARIO / DNI
          </label>
          <input
            id="username"
            name="username"
            type="text"
            value={values.username}
            onChange={handleFieldChange}
            placeholder="EJ: juanperez"
            className={inputClass('username')}
          />
          {errors.username && (
            <p className="mt-1 text-xs font-medium text-red-600">{errors.username}</p>
          )}
        </div>
        <div>
          <label htmlFor="idRol" className="mb-1 block text-xs font-semibold uppercase tracking-[0.08em] text-slate-600">
            ROL
          </label>
          <select
            id="idRol"
            name="idRol"
            value={values.idRol}
            onChange={handleFieldChange}
            className={inputClass('idRol')}
          >
            <option value="">SELECCIONE ROL...</option>
            <option value="1">Administrador</option>
            <option value="3">Asesor</option>
            <option value="4">Auditor</option>
            <option value="5">Cajero</option>
            <option value="6">Operaciones</option>
            <option value="7">Contabilidad</option>
          </select>
          {errors.idRol && (
            <p className="mt-1 text-xs font-medium text-red-600">{errors.idRol}</p>
          )}
        </div>

        {isEditing && !editPassword && (
          <div className="col-span-2">
            <button
              type="button"
              className="mb-1 inline-flex items-center rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
              onClick={onEnablePasswordEdit}
            >
              CAMBIAR CONTRASEÑA
            </button>
          </div>
        )}

        <div>
          <label htmlFor="password" className="mb-1 block text-xs font-semibold uppercase tracking-[0.08em] text-slate-600">
            CONTRASEÑA
          </label>
          <input
            id="password"
            type="password"
            name="password"
            value={values.password}
            onChange={handleFieldChange}
            placeholder="EJ: contraseña123@"
            className={inputClass('password')}
            autoComplete="new-password"
            disabled={isEditing && !editPassword}
          />
          {errors.password && (isEditing ? editPassword : true) && (
            <p className="mt-1 text-xs font-medium text-red-600">{errors.password}</p>
          )}
        </div>
        <div>
          <label htmlFor="password_confirmation" className="mb-1 block text-xs font-semibold uppercase tracking-[0.08em] text-slate-600">
            CONFIRMAR CONTRASEÑA
          </label>
          <input
            id="password_confirmation"
            type="password"
            name="password_confirmation"
            value={values.password_confirmation}
            onChange={handleFieldChange}
            placeholder="EJ: contraseña123@"
            className={inputClass('password_confirmation')}
            autoComplete="new-password"
            disabled={isEditing && !editPassword}
          />
          {errors.password_confirmation && (
            <p className="mt-1 text-xs font-medium text-red-600">{errors.password_confirmation}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default DatosAcceso;
